module.exports = __webpack_public_path__ + "static/media/wsf-logo.b8ed5fe0.svg";